<template>
  <div class="v-icon mr-2 ">
    <v-dialog 
    :value="editCourseTypeDialog" 
    max-width="500px" 
    persistent
    >
      <v-card>
        <DialogTitle 
        :close="closeEditItem" 
        :dialog-name="dialogName" 
        />
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex 
              md12 
              sm12 
              xs12
              >
                <v-text-field 
                counter 
                label="Name" 
                maxlength="90" 
                v-model="editName" 
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <DialogActions 
        :close="closeEditItem" 
        :save="saveEditItemAndCloseDialog" 
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EditTableFunctions from '@/components/editTableFunctions';
import { mapActions, mapMutations } from "vuex";

import { FETCH_COURSE_TYPE_LIST, SAVE_EDITED_COURSE_TYPE } from "@/store/course_type/actions.js";
import { LOAD_COURSE_TYPE_TO_EDIT, RESET_DEFAULT_COURSE_TYPE_TO_EDIT, TOGGLE_EDIT_COURSE_TYPE_DIALOG, UPDATE_COURSE_TYPE_FIELD } from "@/store/course_type/mutations";
import DialogActions from "../../../components/DialogActions";
import DialogTitle from "../../../components/DialogTitle";

export default {
  name: "EditCourseTypeDialog",
  validations: {
  },
  components: {
    DialogActions,
    DialogTitle
  },
  mixins: [
    EditTableFunctions,
  ],
  props: {
  },
  data() {
    return {
      // Required for editTableFunctions
      dialogName: 'Edit Course Type',
    }
  },
  computed: {
    editCourseTypeDialog: {
      get() {
        return this.$store.state.courseType.editCourseTypeDialog;
      },
    },
    editName: {
      get() {
        return this.$store.state.courseType.editCourseType.name;
      },
      set(value) {
        this.updateEditedValue('name', value);
      },
    },
  },
  mounted() {
  },
  methods: {
    async validateAll() {
      this.$v.$touch();
      let formState = false;
      if (this.$v.$anyDirty === false) {
        formState = 'clean';
      } else {
        if (this.$v.$anyError === true) {
          formState = 'error';
        } else {
          formState = 'complete';
        }
      }

      let areValid = false;

      if (formState == 'complete') {
        areValid = true;
      }

      return areValid;
    },
    ...mapActions({
      fetchItem: FETCH_COURSE_TYPE_LIST,
      updateTableItemRecord: SAVE_EDITED_COURSE_TYPE,
    }),
    ...mapMutations({
      toggleEditDialog: TOGGLE_EDIT_COURSE_TYPE_DIALOG,
      loadTableItemToEdit: LOAD_COURSE_TYPE_TO_EDIT,
      updateTableItemToEdit: UPDATE_COURSE_TYPE_FIELD,
      resetEditItemToDefault: RESET_DEFAULT_COURSE_TYPE_TO_EDIT,
    }),
  },
}
</script>